module.exports = __webpack_public_path__ + "img/logo_infineon.6d0ab871.png";